
import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-md'
          : 'bg-transparent backdrop-blur-sm'
      }`}
    >
      <div className="w-full px-8 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/84612608-2987-46a9-95ff-5e019e6ef485.png" 
              alt="FRIGOAVE Logo" 
              className="h-10 w-auto"
            />
          </div>

          <div className="flex items-center gap-10">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-base font-light transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-800 hover:text-cyan-500' : 'text-white hover:text-cyan-300'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-base font-light transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-800 hover:text-cyan-500' : 'text-white hover:text-cyan-300'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('vpn-service')}
              className={`text-base font-light transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-800 hover:text-cyan-500' : 'text-white hover:text-cyan-300'
              }`}
            >
              VPN Service
            </button>
            <button
              onClick={() => scrollToSection('security')}
              className={`text-base font-light transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-800 hover:text-cyan-500' : 'text-white hover:text-cyan-300'
              }`}
            >
              Security &amp; Privacy
            </button>
            <button
              onClick={() => scrollToSection('support')}
              className={`text-base font-light transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-800 hover:text-cyan-500' : 'text-white hover:text-cyan-300'
              }`}
            >
              Support
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-base font-light transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-800 hover:text-cyan-500' : 'text-white hover:text-cyan-300'
              }`}
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="px-8 py-3 bg-gradient-to-r from-cyan-400 to-blue-500 text-white rounded-xl font-medium hover:shadow-lg transition-all whitespace-nowrap"
          >
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}
